import { render, staticRenderFns } from "./LicenseManagement.vue?vue&type=template&id=5c61f50d&scoped=true&"
import script from "./LicenseManagement.vue?vue&type=script&lang=js&"
export * from "./LicenseManagement.vue?vue&type=script&lang=js&"
import style0 from "./LicenseManagement.vue?vue&type=style&index=0&id=5c61f50d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61f50d",
  null
  
)

export default component.exports